<template>
  <nav class="categories">
    <ul>
      <li>
        <nuxt-link
            :class="{active: !route.params.category}"
            :to="{
                path: localePath(link),
                query: {}
              }"
            class="btn"
        >
          {{ t('all_items_label') }}
        </nuxt-link>
      </li>
      <li
          v-for="category in categories"
          :key="category"
      >
        <nuxt-link
            :class="{active: route.params.category === getModifiedString(category)}"
            :to="{
              path: localePath(link + '/' + getModifiedString(category)),
              query: {}
            }"
            class="btn"
        >
          {{ t('filters.weapon.' + category) }}
        </nuxt-link>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>

const props = defineProps<{
  categories: string[]
  link: string
}>()
const localePath = useLocalePath()
const {t} = useI18n()
const route = useRoute()
</script>

<style lang="scss" scoped>
@use 'sass:color';

.categories {
  ul {
    display: flex;
    gap: 8px;
    padding: 8px 0;
    overflow-x: auto;
  }

  li {
    list-style: none;
  }

  .btn {
    color: var(--surfaces-on-surface-variable);
    transition: background-color 0.3s;
    padding: 6.5px 8px;
    border-radius: 6px;
    border: 1px solid var(--surfaces-outline);
    background: var(--surfaces-container);
    font-weight: 400;
    white-space: nowrap;

    &:hover, &:focus {
      background-color: color-mix(IN srgb, var(--surfaces-container) 95%, white);
    }

    &.active {
      background: var(--accent-secondary);
      color: #fff;

      &:hover, &:focus {
        background: color-mix(in srgb, var(--accent-secondary) 95%, white);
      }
    }
  }
}
</style>
